module.exports = "https://cdn.redage.net/src/views/games/other/images/roles/komisar.png";